module.exports = __webpack_public_path__ + "img/electric_no_zone.38e1797d.svg";